// extracted by mini-css-extract-plugin
module.exports = {"section":"Interested_section__BlXi_","box":"Interested_box__s5qHO","item":"Interested_item__Rmplp","image":"Interested_image__x8buU","title":"Interested_title__5WwtG"};